// extracted by mini-css-extract-plugin
module.exports = {"container":"_c-","row":"_c_"};